import { React, useEffect, useState, useContext, useRef } from 'react';
import { AuthContext } from '../../../../contexts/authContext';
import { useParams, useNavigate } from "react-router-dom";
import { useDisclosure } from '@mantine/hooks';

import { addYears, addDays } from 'date-fns';

import { TextInput, Modal, FileButton, Textarea, Autocomplete, Select, Button, Loader, Checkbox } from '@mantine/core';
import { useForm } from '@mantine/form';
import { DatePickerInput } from '@mantine/dates';
import { IconX, IconCalendar, IconPlus, IconTrash } from '@tabler/icons-react';

import AppHdWithReturnLeft from '../../../../composents/Headers/AppHeaders/AppHdWithReturnLeft/AppHdWithReturnLeft'
import AppHdWithCloseRight from '../../../../composents/Headers/AppHeaders/AppHdWithCloseRight/AppHdWithCloseRight';
import SyndicRectangleButton from '../../../../composents/Buttons/Syndic/RectangleButton/RectangleButtonMain';
import RectangleButtonDisabled from '../../../../composents/Buttons/All/RectangleButtonDisabled/RectangleButtonDisabled';
import AppDesktopLogo from '../../../../composents/Logo/AppDesktopLogo/AppDesktopLogo';
import ResourceCategorySelect from '../../../../components/Constants/ResourceCategorySelect';
import RessourcesRequiringWeight from '../../../../components/Constants/RessourcesRequiringWeight';

const EditOfferBeforePublication = (props) => {
    const { getToken } = useContext(AuthContext);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768); 
    const [offerInfo, setOfferInfo] = useState(JSON.parse(sessionStorage.getItem("offer")));
    const [previewPictures, setPreviewPictures] = useState([]);
    const [tempRange, setTempRange] = useState([]);
    const [submitError, setSubmitError] = useState(null);
    const [cautionModalOpened, setCautionModalOpened] = useState(false);
    const [pendingSubmit, setPendingSubmit] = useState(null);
    const cautionInputRef = useRef(null);

    const [query, setQuery] = useState(offerInfo.cityOfIntervention);
    const [options, setOptions] = useState([]);
    const [ openedImgLimit, { open : openModalImgLimit, close : closeModalImgLimit }] = useDisclosure(false);
    const [ openedExistingImg, { open: openModalExistingImg, close: closeModalExistingImg}] = useDisclosure(false)
    const [ openedTooBigImg, { open: openModalTooBigImg, close: closeModalTooBigImg}] = useDisclosure(false)
    const [ openedModalWrongType, { open: openModalWrongType, close: closeModalWrongType}] = useDisclosure(false);

    const navigate = useNavigate();

    let {id} = useParams()

    useEffect(() => {
        const token = getToken();
        if (!token) {
            navigate("/app/login");
            return;
        };
        if (!offerInfo) return;
        const availabilityRanges = (offerInfo.availabilityDates?.map(period => [
            new Date(period.startDate),
            new Date(period.endDate)
        ]) || []).sort((a, b) => a[0] - b[0]);
         
        setPreviewPictures(offerInfo.pictures)

        form.setValues({
            title: offerInfo.title,
            contrat: offerInfo.contrat,
            cityOfIntervention: offerInfo.cityOfIntervention,
            availabilityDates: availabilityRanges,
            ressource: offerInfo.ressource,
            description: offerInfo.description,
            rules: offerInfo.rules,
            price: offerInfo.price?.toFixed(2).replace('.', ',') || '',
            caution: offerInfo.caution != null ? String(offerInfo.caution) : '',
            allowWeekends: offerInfo.allowWeekends !== false,
            allowHolidays: offerInfo.allowHolidays !== false,
            rentUnit : offerInfo.rentUnit || 'jour',
            handDelivery: offerInfo.handDelivery !== false,
            shipping: offerInfo.shipping === true,
            weightKg: offerInfo.weightKg != null ? String(offerInfo.weightKg) : '',
          });

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
            };
            window.addEventListener('resize', handleResize);
            return () => {
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);

   
    const form = useForm({
        initialValues: {
            title: '',
            contrat: '',
            cityOfIntervention: '',
            availabilityDates: [],
            ressource: '',
            description: '',
            rules: '',
            price: 0,
            caution: '',
            allowWeekends: true,
            allowHolidays: true,
            rentUnit: '',
            pictures:[],
            handDelivery: true,
            shipping: false,
            weightKg: ''
        },

        validate: {
            title : (value) => (
                value.length < 1
                ? 'Renseignez le titre de votre offre'
                : value.length > 100
                ? '100 caractères maximum'
                : null
            ),
            availabilityDates: (value, values) => {
                if (values.contrat === "Location") {
                    if (!value || value.length === 0) {
                    return "Sélectionnez les dates de disponibilités de votre location";
                    }
                }
                return null;
            },
            weightKg: (value, values) => {
                // Le poids ne sert qu'au calcul CO2, jamais fait pour une Location (cf. backend
                // calculateAvoidedCO2 qui retourne null immédiatement pour une Location) — donc
                // pas la peine de le demander dans ce cas.
                if (values.contrat !== "Location" && RessourcesRequiringWeight.includes(values.ressource)) {
                    const parsed = parseFloat(String(value).replace(',', '.'));
                    if (!value || isNaN(parsed) || parsed <= 0) {
                        return "Indiquez le poids (en kg) de cette ressource";
                    }
                }
                return null;
            },
            price: (value, values) => {
                const priceValue = parseFloat(String(value).replace(',', '.'));
                if (values.contrat !== "Don" && priceValue < 1) {
                    return "Le prix minimum est de 1 €";
                }
                return null;
            },
            description : (value) => (value.length > 1000 ? '1000 caractères maximum' : null),
            rules : (value) => (value.length > 1000 ? '1000 caractères maximum' : null),
            cityOfIntervention: (value) => (
                /^\d{5}\s.+/.test(String(value || '').trim())
                    ? null
                    : 'Sélectionnez une ville dans la liste proposée (code postal et commune)'
            )
        },
    });

    // Changer de type de contrat invalide les plages de disponibilités déjà
    // saisies : elles n'ont de sens que pour une Location, pas pour quitter
    // ce type vers Vente/Don.
    const handleContratChange = (newContrat) => {
        if (form.values.contrat === "Location" && newContrat !== "Location") {
            form.setFieldValue("availabilityDates", []);
            setTempRange([]);
        }
        form.setFieldValue("contrat", newContrat);
    };

    const handleQueryChange = async (value) => {
    setQuery(value);

    if (value.length < 2) {
        setOptions([]);
        return;
    }

    try {
        const response = await fetch(
        `https://api-adresse.data.gouv.fr/search/?q=${value}&type=municipality&limit=5`
        );

        const data = await response.json();

        const suggestions = data.features.map((feature) => {
        const city = feature.properties.city;
        const postcode = feature.properties.postcode;

        return {
            value: `${postcode} ${city}`,
            label: `${postcode} ${city}`
        };
        });

        setOptions(suggestions);
    } catch (error) {
        console.error(error);
    }
    }; 

    const doSubmitEdit = async (values, _event) => {
          const formattedDates = values.availabilityDates.map((range) => ({
            startDate: range[0],
            endDate: range[1]
        }));

        const priceNumber = parseFloat(String(form.values.price).replace(',', '.'));        try {
            const token = localStorage.getItem('token');
            const response = await fetch(`https://boldee-97d8d36af3bd.herokuapp.com/app/offers/offer-edit/${id}`, {
                method: "POST",
                body: JSON.stringify({
                    id: id,
                    title: values.title,
                    contrat: values.contrat,
                    cityOfIntervention: values.cityOfIntervention,
                    availabilityDates: formattedDates,
                    ressource: values.ressource,
                    description: values.description,
                    rules: values.rules,
                    price: priceNumber,
                    caution: values.contrat === "Location" && values.caution !== ''
                        ? parseFloat(String(values.caution).replace(',', '.'))
                        : null,
                    allowWeekends: values.allowWeekends,
                    allowHolidays: values.allowHolidays,
                    rentUnit: values.rentUnit,
                    pictures: previewPictures,
                    handDelivery: values.handDelivery,
                    shipping: values.shipping,
                    weightKg: values.contrat !== "Location" && RessourcesRequiringWeight.includes(values.ressource) && values.weightKg !== ''
                        ? parseFloat(String(values.weightKg).replace(',', '.'))
                        : undefined,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            });
            const updatedOffer = await response.json();
            if (!response.ok) {
                const message = Array.isArray(updatedOffer?.message) ? updatedOffer.message.join(' ') : (updatedOffer?.message || "Une erreur est survenue, veuillez réessayer.");
                setSubmitError(message);
                return;
            }
            setSubmitError(null);
            setOfferInfo(updatedOffer);


            await fetch(`https://boldee-97d8d36af3bd.herokuapp.com/app/offers/add-offer/${id}`, {
                method: "POST",
                body: JSON.stringify({
                    id: id,
                }),
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`
                }
            });
            setTimeout(() => {
                navigate('/app/offers/list');
            }, 500)

        } catch (error) {
            setSubmitError("Une erreur est survenue, veuillez réessayer.");
        }
    }

    const handleFormSubmit = (values, _event) => {
        _event.preventDefault();
        const cautionValue = parseFloat(String(values.caution).replace(',', '.'));
        const cautionEmpty = values.contrat === "Location" &&
            (values.caution === '' || isNaN(cautionValue) || cautionValue === 0);
        if (cautionEmpty) {
            setPendingSubmit({ values, event: _event });
            setCautionModalOpened(true);
            return;
        }
        doSubmitEdit(values, _event);
    };

    const handleFormChange = (event) => {
        const { name, value } = event.currentTarget;
        form.setFieldValue(name, value);
    };

    const fileBrowseHandler = (event) => {
        let updatedPreviewPictures = [];
        const limitImages = 3
        const maxSizeInBytes = 10*1024*1024

        for(let i = 0;i < event.length;i++){
            if(event[i].size > maxSizeInBytes) {
                openModalTooBigImg()
            } else if(event[i].type !== 'image/png' && event[i].type !== 'image/jpeg' && event[i].type !== 'image/jpg'){
                openModalWrongType()
            } else if (event[i].size <= maxSizeInBytes) {

            let reader = new FileReader();
            reader.readAsDataURL(event[i])
            reader.onload = () => {
                if(!previewPictures.concat(updatedPreviewPictures).includes(reader.result)){
                    updatedPreviewPictures.push(reader.result);
                    if(previewPictures.concat(updatedPreviewPictures).length <= limitImages ) {
                        setPreviewPictures(previewPictures.concat(updatedPreviewPictures))
                    } else if (previewPictures.concat(updatedPreviewPictures).length > limitImages){
                        setPreviewPictures(previewPictures.concat(updatedPreviewPictures).slice(0,3))
                        openModalImgLimit()
                    }
                } else if (previewPictures.concat(updatedPreviewPictures).includes(reader.result)) {
                    openModalExistingImg()
                }
            }
            reader.onerror = function (error) {
            }
            }
        }      
    }

    const isFrenchHoliday = (date) => {
        const y = date.getFullYear(), m = date.getMonth() + 1, d = date.getDate();
        const a = y % 19, b = Math.floor(y / 100), c = y % 100;
        const dd = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
        const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - dd - g + 15) % 30;
        const i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
        const mm = Math.floor((a + 11 * h + 22 * l) / 451);
        const easterMonth = Math.floor((h + l - 7 * mm + 114) / 31);
        const easterDay = ((h + l - 7 * mm + 114) % 31) + 1;
        const easter = new Date(y, easterMonth - 1, easterDay);
        const lundi = new Date(easter); lundi.setDate(easter.getDate() + 1);
        const ascension = new Date(easter); ascension.setDate(easter.getDate() + 39);
        const pentecote = new Date(easter); pentecote.setDate(easter.getDate() + 50);
        const fixed = [[1,1],[5,1],[5,8],[7,14],[8,15],[11,1],[11,11],[12,25]];
        const isFixed = fixed.some(([fm, fd]) => m === fm && d === fd);
        const isMoving = [lundi, ascension, pentecote].some(fv =>
            fv.getFullYear() === y && fv.getMonth() + 1 === m && fv.getDate() === d
        );
        return isFixed || isMoving;
    };

    const deleteImg = (event) => {
        const pictureToDelete = previewPictures.filter(picture => picture !== event.currentTarget.value);
        setPreviewPictures(pictureToDelete);
    };

    const normalize = (d) =>
        new Date(d.getFullYear(), d.getMonth(), d.getDate());

    return(
        offerInfo ?
            <>
                <Modal
                    opened={cautionModalOpened}
                    onClose={() => setCautionModalOpened(false)}
                    title="Vous n'avez pas défini de caution"
                    centered
                    withCloseButton={false}
                >
                    <p className="noMrgT">La caution vous protège en cas de dommage ou de non-restitution du bien. Sans caution, vous n'avez aucune garantie en cas de souci.</p>
                    <div className="mrgB10"></div>
                    <Button
                        fullWidth
                        color="dark"
                        onClick={() => {
                            setCautionModalOpened(false);
                            setTimeout(() => cautionInputRef.current?.focus(), 100);
                        }}
                    >
                        Ajouter une caution
                    </Button>
                    <div className="mrgB10"></div>
                    <Button
                        fullWidth
                        variant="outline"
                        color="gray"
                        onClick={() => {
                            setCautionModalOpened(false);
                            if (pendingSubmit) {
                                doSubmitEdit(pendingSubmit.values, pendingSubmit.event);
                                setPendingSubmit(null);
                            }
                        }}
                    >
                        Continuer sans caution
                    </Button>
                </Modal>
                {isMobile ? (
                    <>
                        <AppHdWithReturnLeft isEditOffer={true}> 
                            Modifier mon offre
                        </AppHdWithReturnLeft>
                        <form onSubmit={form.onSubmit(handleFormSubmit)}>
                        <div className="width90pCenter">
                            <div className="horizontal jCenter">
                                    {previewPictures.length > 0
                                        ?   <div className='horizontal jCenter mrgB5'>
                                                {previewPictures.map((picture => (
                                                    <div key = {picture} style = {{marginRight : '5px'}} className='vertical imgRelative'>
                                                        <img className="img78x78T" src={picture} alt='img_rsc'/>
                                                        <button value={picture} onClick={deleteImg} className='btnReset imgDeleteImgBtnAbsolute mrgR5 mrgT5 bold bLiteTransparent'><IconX width={13} height={13}/></button>
                                                    </div>  
                                                )))}
                                            </div>
                                        : ""
                                    }

                                    <FileButton
                                        className='img78x78T' 
                                        multiple
                                        onChange={fileBrowseHandler}
                                        accept="image/png,image/jpeg,image/jpg">
                                        {(props) => <Button color="gray" {...props}>
                                            <div className='vertical iCenter'>
                                                <IconPlus width={20}/> 
                                                <p className='noMrgTB'>Ajouter photo (3 max)</p>
                                            </div> 
                                        </Button>}
                                    </FileButton>
                                    {openModalImgLimit  
                                        ?   <Modal 
                                                centered
                                                size="auto"
                                                opened={openedImgLimit}
                                                onClose={closeModalImgLimit}
                                                withCloseButton={false}>
                                                <p className=" txt15 txtCenter noMrgTB">
                                                    Chargement de 3 photos maximum
                                                </p>
                                            </Modal> 
                                        :   ""
                                    }

                                    {openModalExistingImg  
                                        ?   <Modal 
                                                centered
                                                size="auto"
                                                opened={openedExistingImg}
                                                onClose={closeModalExistingImg}
                                                withCloseButton={false}>
                                                <p className="tCenter noMrgTB">
                                                    Photo déjà téléchargée
                                                </p>
                                            </Modal> 
                                        :   ""
                                    }
                                    
                                    {openModalTooBigImg  
                                        ?   <Modal 
                                                centered
                                                size="auto"
                                                opened={openedTooBigImg}
                                                onClose={closeModalTooBigImg}
                                                withCloseButton={false}>
                                                <p className=" txt15 txtCenter noMrgTB">
                                                    10 Mo Maximum par photo
                                                </p>
                                            </Modal> 
                                        :   ""
                                    }
                                    {openModalWrongType 
                                        ?   <Modal 
                                                centered
                                                size="auto"
                                                opened={openedModalWrongType}
                                                onClose={closeModalWrongType}
                                                withCloseButton={false}>
                                                <p className=" txt15 txtCenter noMrgTB">
                                                    Fichiers autorisés : .png, .jpeg, .jpg
                                                </p>
                                            </Modal> 
                                        :   ""
                                    }
                                </div>
                                <div className='mrgB10'></div>
                                 <Select
                                    variant="filled"
                                    placeholder={offerInfo.contrat}
                                    data={[
                                        { value: 'Vente', label: 'Vente' },
                                        { value: 'Location', label: 'Location/Prestation' },
                                        { value: 'Don', label: 'Don' },
                                    ]}
                                    withAsterisk
                                    {...form.getInputProps('contrat')}
                                    onChange={handleContratChange}
                                        styles={{
                                        input: {
                                            color: 'black',
                                            fontWeight: 600,
                                        },
                                        placeholder: {
                                            fontWeight: 600,
                                        },
                                    }}
                                /> 
                                <div className="mrgB10"></div>
                                {form.values.contrat === "Location" && (
                                    <>    
                                    <DatePickerInput
                                        type="range"
                                        allowSingleDateInRange
                                        value={tempRange}
                                        onChange={setTempRange}
                                        minDate={addDays(new Date(), 1)}
                                        maxDate={addYears(new Date(), 3)}
                                        placeholder="📅 Sélectionnez une plage"
                                        valueFormat="DD MMM YYYY"
                                        locale="fr"
                                        excludeDate={(date) => {
                                            const day = date.getDay();
                                            if (!form.values.allowWeekends && (day === 0 || day === 6)) return true;
                                            if (!form.values.allowHolidays && isFrenchHoliday(date)) return true;
                                            return form.values.availabilityDates?.some((range) => {
                                                if (!range?.[0] || !range?.[1]) return false;
                                                const current = normalize(date);
                                                const start = normalize(range[0]);
                                                const end = normalize(range[1]);
                                                return current >= start && current <= end;
                                            });
                                        }}
                                    />

                                    <div style={{ display: "flex", gap: 16, marginTop: 8 }}>
                                        <Checkbox
                                            label="Autoriser les week-ends"
                                            checked={form.values.allowWeekends}
                                            onChange={(e) => form.setFieldValue('allowWeekends', e.currentTarget.checked)}
                                        />
                                        <Checkbox
                                            label="Autoriser les jours fériés"
                                            checked={form.values.allowHolidays}
                                            onChange={(e) => form.setFieldValue('allowHolidays', e.currentTarget.checked)}
                                        />
                                    </div>

                                    <Button
                                    color='dark'
                                    className='mrgT10'
                                    onClick={() => {
                                        if (tempRange && tempRange[0] && tempRange[1] && new Date(tempRange[0]) <= new Date(tempRange[1])) {
                                        const updatedRanges = [
                                            ...form.values.availabilityDates,
                                            tempRange,
                                        ].sort((a, b) => a[0] - b[0]);
                                        form.setFieldValue("availabilityDates", updatedRanges);
                                        setTempRange([]);
                                        }
                                    }}
                                    >
                                        Ajouter la plage
                                    </Button>
                                    </>
                                )}
                                {form.values.contrat === "Location" && tempRange && tempRange[0] && !tempRange[1] && (
                                    <p style={{ color: 'red', fontSize: '13px', margin: '4px 0 0' }}>
                                        Cliquez sur "Ajouter la plage" pour valider vos dates
                                    </p>
                                )}
                                {form.values.contrat === "Location" && form.errors.availabilityDates && (
                                    <p style={{ color: 'red', fontSize: '13px', margin: '4px 0 0' }}>
                                        {form.errors.availabilityDates}
                                    </p>
                                )}
                                <div className="mrgB10"></div>
                                {form.values.availabilityDates?.map((range, index) =>
                                    range?.[0] && range?.[1] ? (
                                        <div
                                        key={index}
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            marginBottom: "8px",
                                        }}
                                        >
                                        <div>
                                            {range[0].toLocaleDateString("fr-FR")} -{" "}
                                            {range[1].toLocaleDateString("fr-FR")}
                                        </div>

                                        <IconTrash
                                            size={18}
                                            style={{ cursor: "pointer", color: "#000000" }}
                                            onClick={() => form.removeListItem("availabilityDates", index)}
                                        />
                                        </div>
                                    ) : null
                                )}
                                <div className="mrgB10"></div>   
                                <TextInput
                                    variant="filled"
                                    placeholder={offerInfo.title}
                                    withAsterisk
                                    onChange={handleFormChange}
                                    {...form.getInputProps('title')}
                                        styles={{
                                        input: {
                                            color: 'black',
                                            fontWeight: 600,
                                        },
                                        placeholder: {
                                            fontWeight: 600,
                                        },
                                        groupLabel: {
                                            fontSize: '13px',
                                            fontWeight: 700,
                                            color: '#2e7d32',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            paddingTop: '8px',
                                        },
                                    }}
                                />
                                <div className="mrgB10"></div>

                                <Textarea
                                    variant="filled"
                                    placeholder={offerInfo.description}
                                    onChange={handleFormChange}
                                    {...form.getInputProps('description')}
                                    styles={{
                                        input: {
                                            color: 'black',
                                            fontWeight: 600,
                                        },
                                        placeholder: {
                                        fontWeight: 600,
                                        },
                                    }}
                                    minRows={5}
                                    />
                                <div className="mrgB10"></div>

                                {form.values.contrat === "Vente" && (
                                    <>
                                    <div style={{ display: "flex", gap: 16 }}>
                                        <Checkbox
                                            label="Remise en main propre"
                                            checked={form.values.handDelivery}
                                            onChange={(e) => {
                                                const checked = e.currentTarget.checked;
                                                if (!checked && !form.values.shipping) return;
                                                form.setFieldValue('handDelivery', checked);
                                            }}
                                        />
                                        <Checkbox
                                            label="Livraison"
                                            checked={form.values.shipping}
                                            onChange={(e) => {
                                                const checked = e.currentTarget.checked;
                                                if (!checked && !form.values.handDelivery) return;
                                                form.setFieldValue('shipping', checked);
                                            }}
                                        />
                                    </div>
                                    <div className="mrgB10"></div>
                                    </>
                                )}

                                <Textarea
                                    variant="filled"
                                    placeholder={offerInfo.rules || "Autres instructions - ex : Horaires, Parking, Accès, etc."}
                                    onChange={handleFormChange}
                                    {...form.getInputProps('rules')}
                                    styles={{
                                        input: {
                                            color: 'black',
                                            fontWeight: 600,
                                        },
                                        placeholder: {
                                        fontWeight: 600,
                                        },
                                    }}
                                    minRows={5}
                                    />
                                <div className="mrgB10"></div>

<Autocomplete
  label="Ville ou code postal"
  placeholder="Ex : Paris ou 75012"
  value={query}
  error={form.errors.cityOfIntervention}
  onChange={(value) => {
    setQuery(value);
    form.setFieldValue("cityOfIntervention", "");
    handleQueryChange(value);
  }}
  onItemSubmit={(item) => {
                                const value = item.value;
    form.setFieldValue("cityOfIntervention", value);
    setQuery(value);
    form.clearFieldError("cityOfIntervention");
  }}
  onBlur={() => form.validateField("cityOfIntervention")}
  data={options}
/>
                                <div className="mrgB20"></div>
                                
                                <ResourceCategorySelect
                                    placeholder={offerInfo.ressource}
                                    {...form.getInputProps('ressource')}
                                />
                                <div className="mrgB10"></div>

                                {form.values.contrat !== "Location" && RessourcesRequiringWeight.includes(form.values.ressource) && (
                                    <>
                                        <TextInput
                                            label="Poids (kg)"
                                            placeholder="Ex : 25"
                                            withAsterisk
                                            {...form.getInputProps('weightKg')}
                                        />
                                        <p className="txt11 thin dGreyT">Utilisé pour estimer le CO₂ potentiellement évité par le réemploi.</p>
                                        <div className="mrgB10"></div>
                                    </>
                                )}

                                {(form.values.contrat === "Location" || form.values.contrat === "Vente") &&
                                    <div className='horizontal iEnd'>
                                    <div className='w90'>
                                        <TextInput
                                            label="Prix"
                                            withAsterisk
                                            {...form.getInputProps('price')}
                                            onChange={(event) => form.setFieldValue('price', event.currentTarget.value)}
                                            rightSection="€"
                                            styles={{
                                                input: { color: 'black', fontWeight: 600 },
                                                placeholder: { fontWeight: 600 },
                                            }}
                                            error={
                                                !/^(\d+([.,]\d{0,2})?)?$/.test(form.values.price)
                                                ? 'Veuillez entrer un nombre valide (max 2 décimales)'
                                                : null
                                            }
                                        />
    
                                    </div>
                                    <div className='mrgR10'></div>
                                    <div className='w50'>
                                        {form.values.contrat === "Location" &&
                                            <Select
                                                variant="filled"
                                                placeholder={offerInfo.rentUnit}
                                                data={[
                                                    { value: 'jour', label: '/ jour' },
                                                ]}
                                                withAsterisk
                                                required
                                                onChange={handleFormChange}
                                                {...form.getInputProps('rentUnit')}
                                                styles={{
                                                    input: {
                                                        color: 'black',
                                                        fontWeight: 600,
                                                    },
                                                    placeholder: {
                                                        fontWeight: 600,
                                                    },
                                                }}
                                            />
                                        }
                                    </div>
                                    </div>

                                }
                                {form.values.contrat === "Location" && (
                                    <>
                                    <div className="mrgB10"></div>
                                    <TextInput
                                        ref={cautionInputRef}
                                        label="Caution (optionnel)"
                                        placeholder="Montant de la caution"
                                        value={form.values.caution}
                                        onChange={(e) => form.setFieldValue('caution', e.currentTarget.value)}
                                        rightSection="€"
                                        error={
                                            (() => {
                                                if (form.values.caution === '') return null;
                                                if (!/^(\d+([.,]\d{0,2})?)?$/.test(form.values.caution)) return 'Veuillez entrer un nombre valide';
                                                return null;
                                            })()
                                        }
                                        styles={{
                                            input: { color: 'black', fontWeight: 600 },
                                        }}
                                    />
                                    </>
                                )}
                                <div className="mrgB10"></div>

                                {submitError && (
                                    <p style={{ color: '#e03131', fontSize: 13, marginBottom: 8 }}>{submitError}</p>
                                )}

                                {form.isDirty() && !(form.values.contrat === "Location" && tempRange && tempRange[0] && !tempRange[1])
                                    ?
                                        <SyndicRectangleButton type="submit">
                                            Publier mon offre
                                        </SyndicRectangleButton>
                                    :   <RectangleButtonDisabled>
                                            Publier mon offre
                                        </RectangleButtonDisabled>
                                }

                            <div className="mrgB30"></div>

                        </div>
                        </form>
                    </>
                ) : (
                    <>
                        <AppDesktopLogo/>
                        <div className="offer-desktop-page-bg">
                        <div className="offer-form-card">
                        <AppHdWithCloseRight>Modifier mon offre</AppHdWithCloseRight>
                        <form className="offer-form-darker-placeholders" onSubmit={form.onSubmit(handleFormSubmit)}>
                            <div>
                                <div className='horizontal jCenter'>
                                    {previewPictures.length > 0 
                                        ?   <div className='horizontal jCenter mrgB5'>
                                                {previewPictures.map( (picture, index) => (
                                                    <div key = {picture} style = {{marginRight : '5px'}} className='vertical imgRelative'>
                                                        <img className='img100x100T' src={picture} alt='img_rsc'/>
                                                        <button value={picture} onClick={deleteImg} className='btnReset imgDeleteImgBtnAbsolute mrgR5 mrgT5 bold bLiteTransparent'><IconX width={13} height={13}/></button>
                                                    </div>
                                                ))}
                                            </div>
                                        :   ""
                                    }

                                    <FileButton
                                        className='img100x100T' 
                                        multiple
                                        onChange={fileBrowseHandler}
                                        accept="image/png,image/jpeg,image/jpg">
                                        {(props) => <Button variant="default" {...props}>
                                            <div className='vertical iCenter'>
                                                <IconPlus width={20}/> 
                                                <p className='noMrgTB txt16'>Ajouter photo (3 max)</p>
                                            </div> 
                                        </Button>}
                                    </FileButton>

                                    {openModalImgLimit  
                                        ?   <Modal 
                                                centered
                                                size="auto"
                                                opened={openedImgLimit}
                                                onClose={closeModalImgLimit}
                                                withCloseButton={false}>
                                                <p className=" txt15 txtCenter noMrgTB">
                                                    Chargement de 3 photos maximum
                                                </p>
                                            </Modal> 
                                        :   ""
                                    }

                                    {openModalExistingImg  
                                        ?   <Modal 
                                                centered
                                                size="auto"
                                                opened={openedExistingImg}
                                                onClose={closeModalExistingImg}
                                                withCloseButton={false}>
                                                <p className=" txt15 txtCenter noMrgTB">
                                                    Photo déjà téléchargée
                                                </p>
                                            </Modal> 
                                        :   ""
                                    }
                                    
                                    {openModalTooBigImg  
                                        ?   <Modal 
                                                centered
                                                size="auto"
                                                opened={openedTooBigImg}
                                                onClose={closeModalTooBigImg}
                                                withCloseButton={false}>
                                                <p className="tCenter noMrgTB">
                                                    10 Mo Maximum par photo
                                                </p>
                                            </Modal> 
                                        :   ""
                                    }
                                    {openModalWrongType 
                                        ?   <Modal 
                                                centered
                                                size="auto"
                                                opened={openedModalWrongType}
                                                onClose={closeModalWrongType}
                                                withCloseButton={false}>
                                                <p className="oMrgTB">
                                                    Fichiers autorisés : .png, .jpeg, .jpg
                                                </p>
                                            </Modal> 
                                        :   ""
                                    }
                                </div>
                                <div className='mrgB10'></div>
                                <Select
                                    variant="filled"
                                    placeholder={offerInfo.contrat}
                                    data={[
                                        { value: 'Vente', label: 'Vente' },
                                        { value: 'Location', label: 'Location/Prestation' },
                                        { value: 'Don', label: 'Don' },
                                    ]}
                                    withAsterisk
                                    {...form.getInputProps('contrat')}
                                    onChange={handleContratChange}
                                    styles={{
                                        input: {
                                            color: 'black',
                                            fontWeight: 600,
                                        },
                                        placeholder: {
                                            fontWeight: 600,
                                        },
                                        groupLabel: {
                                            fontSize: '13px',
                                            fontWeight: 700,
                                            color: '#2e7d32',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            paddingTop: '8px',
                                        },
                                    }}
                                />
                                <div className="mrgB10"></div>

                                {form.values.contrat === "Location" && (
                                    <>
                                    <DatePickerInput
                                    variant="filled"
                                    icon={<IconCalendar size="1.1rem" stroke={1.5} />}
                                    type="range"
                                    value={tempRange}
                                    onChange={setTempRange}
                                    valueFormat="DD MMM YYYY"
                                    locale="fr"
                                    minDate={addDays(new Date(), 1)}
                                    maxDate={addYears(new Date(), 3)}
                                    allowSingleDateInRange
                                    clearable
                                    withAsterisk
                                    excludeDate={(date) => {
                                        const day = date.getDay();
                                        if (!form.values.allowWeekends && (day === 0 || day === 6)) return true;
                                        if (!form.values.allowHolidays && isFrenchHoliday(date)) return true;
                                        return form.values.availabilityDates?.some((range) => {
                                            if (!range?.[0] || !range?.[1]) return false;
                                            const current = normalize(date);
                                            const start = normalize(range[0]);
                                            const end = normalize(range[1]);
                                            return current >= start && current <= end;
                                        });
                                    }}
                                    />

                                <div style={{ display: "flex", gap: 16, marginTop: 8 }}>
                                    <Checkbox
                                        label="Autoriser les week-ends"
                                        checked={form.values.allowWeekends}
                                        onChange={(e) => form.setFieldValue('allowWeekends', e.currentTarget.checked)}
                                    />
                                    <Checkbox
                                        label="Autoriser les jours fériés"
                                        checked={form.values.allowHolidays}
                                        onChange={(e) => form.setFieldValue('allowHolidays', e.currentTarget.checked)}
                                    />
                                </div>
                                <Button
  onClick={() => {
    if (tempRange && tempRange[0] && tempRange[1] && new Date(tempRange[0]) <= new Date(tempRange[1])) {
      const updatedRanges = [
        ...form.values.availabilityDates,
        tempRange,
      ].sort((a, b) => a[0] - b[0]);
      form.setFieldValue("availabilityDates", updatedRanges);
      setTempRange([]);
    }
  }}
>
  Ajouter la plage
</Button>
                                {tempRange && tempRange[0] && !tempRange[1] && (
                                    <p style={{ color: 'red', fontSize: '13px', margin: '4px 0 0' }}>
                                        Cliquez sur "Ajouter la plage" pour valider vos dates
                                    </p>
                                )}
                                {form.errors.availabilityDates && (
                                    <p style={{ color: 'red', fontSize: '13px', margin: '4px 0 0' }}>
                                        {form.errors.availabilityDates}
                                    </p>
                                )}
                                </>
                            )}
                                <div className="mrgB10"></div>

                                <TextInput
                                    variant="filled"
                                    placeholder={offerInfo.title}
                                    withAsterisk
                                    onChange={handleFormChange}
                                    {...form.getInputProps('title')}
                                    styles={{
                                        input: {
                                            color: 'black',
                                            fontWeight: 600,
                                        },
                                        placeholder: {
                                            fontWeight: 600,
                                        },
                                        groupLabel: {
                                            fontSize: '13px',
                                            fontWeight: 700,
                                            color: '#2e7d32',
                                            textTransform: 'uppercase',
                                            letterSpacing: '0.5px',
                                            paddingTop: '8px',
                                        },
                                    }}
                                />
                                <div className="mrgB10"></div>

                                <Textarea
                                    variant="filled"
                                    placeholder={offerInfo.description}
                                    onChange={handleFormChange}
                                    {...form.getInputProps('description')}
                                    styles={{
                                        input: {
                                            color: 'black',
                                            fontWeight: 600,
                                        },
                                        placeholder: {
                                        fontWeight: 600,
                                        },
                                    }}
                                    minRows={5}
                                    />
                                <div className="mrgB10"></div>

                                {form.values.contrat === "Vente" && (
                                    <>
                                    <div style={{ display: "flex", gap: 16 }}>
                                        <Checkbox
                                            label="Remise en main propre"
                                            checked={form.values.handDelivery}
                                            onChange={(e) => {
                                                const checked = e.currentTarget.checked;
                                                if (!checked && !form.values.shipping) return;
                                                form.setFieldValue('handDelivery', checked);
                                            }}
                                        />
                                        <Checkbox
                                            label="Livraison"
                                            checked={form.values.shipping}
                                            onChange={(e) => {
                                                const checked = e.currentTarget.checked;
                                                if (!checked && !form.values.handDelivery) return;
                                                form.setFieldValue('shipping', checked);
                                            }}
                                        />
                                    </div>
                                    <div className="mrgB10"></div>
                                    </>
                                )}

                                <Textarea
                                    variant="filled"
                                    placeholder={offerInfo.rules || "Autres instructions - ex : Horaires, Parking, Accès, etc."}
                                    onChange={handleFormChange}
                                    {...form.getInputProps('rules')}
                                    styles={{
                                        input: {
                                            color: 'black',
                                            fontWeight: 600,
                                        },
                                        placeholder: {
                                        fontWeight: 600,
                                        },
                                    }}
                                    minRows={5}
                                    />
                                <div className="mrgB10"></div>

<Autocomplete
  label="Ville ou code postal"
  placeholder="Ex : Paris ou 75012"
  value={query}
  error={form.errors.cityOfIntervention}
  onChange={(value) => {
    setQuery(value);
    form.setFieldValue("cityOfIntervention", "");
    handleQueryChange(value);
  }}
  onItemSubmit={(item) => {
                                const value = item.value;
    form.setFieldValue("cityOfIntervention", value);
    setQuery(value);
    form.clearFieldError("cityOfIntervention");
  }}
  onBlur={() => form.validateField("cityOfIntervention")}
  data={options}
/>
                                <div className="mrgB10"></div>

                                <ResourceCategorySelect
                                    placeholder={offerInfo.ressource}
                                    {...form.getInputProps('ressource')}
                                />
                                <div className="mrgB10"></div>

                                {form.values.contrat !== "Location" && RessourcesRequiringWeight.includes(form.values.ressource) && (
                                    <>
                                        <TextInput
                                            label="Poids (kg)"
                                            placeholder="Ex : 25"
                                            withAsterisk
                                            {...form.getInputProps('weightKg')}
                                        />
                                        <p className="txt11 thin dGreyT">Utilisé pour estimer le CO₂ potentiellement évité par le réemploi.</p>
                                        <div className="mrgB10"></div>
                                    </>
                                )}

                                {(form.values.contrat === "Location" || form.values.contrat === "Vente") &&
                                    <div className='horizontal'>
                                    <div className='w90'>
                                        <TextInput
                                        label="Prix"
                                        withAsterisk
                                        {...form.getInputProps('price')}
                                        onChange={(event) => form.setFieldValue('price', event.currentTarget.value)}
                                        rightSection="€"
                                        styles={{
                                            input: { color: 'black', fontWeight: 600 },
                                            placeholder: { fontWeight: 600 },
                                        }}
                                        error={
                                            !/^(\d+([.,]\d{0,2})?)?$/.test(form.values.price)
                                            ? 'Veuillez entrer un nombre valide (max 2 décimales)'
                                            : null
                                        }
                                        />
                                    </div>
                                    <div className='mrgR10'></div>
                                    <div className='w50'>
                                        {form.values.contrat === "Location" &&
                                            <Select
                                                label=" "
                                                variant="filled"
                                                data={[
                                                    { value: 'jour', label: '/ jour' },
                                                ]}
                                                withAsterisk
                                                {...form.getInputProps('rentUnit')}
                                                styles={{
                                                    input: {
                                                        color: 'black',
                                                        fontWeight: 600,
                                                    },
                                                    placeholder: {
                                                        fontWeight: 600,
                                                    },
                                                }}
                                            />
                                        }
                                    </div>
                                    </div>

                                }
                                {form.values.contrat === "Location" && (
                                    <>
                                    <div className="mrgB10"></div>
                                    <TextInput
                                        ref={cautionInputRef}
                                        label="Caution (optionnel)"
                                        placeholder="Montant de la caution"
                                        value={form.values.caution}
                                        onChange={(e) => form.setFieldValue('caution', e.currentTarget.value)}
                                        rightSection="€"
                                        error={
                                            (() => {
                                                if (form.values.caution === '') return null;
                                                if (!/^(\d+([.,]\d{0,2})?)?$/.test(form.values.caution)) return 'Veuillez entrer un nombre valide';
                                                return null;
                                            })()
                                        }
                                        styles={{
                                            input: { color: 'black', fontWeight: 600 },
                                        }}
                                    />
                                    </>
                                )}
                                <div className="mrgB20"></div>
                                <div className="horizontal jCenter">
                                    <Button
                                        type="submit"
                                        color="dark"
                                        radius="xl"
                                        size="lg"
                                        styles={{ label: { fontSize: 16, fontWeight: 500 } }}
                                        disabled={!form.isDirty() || (form.values.contrat === "Location" && tempRange && tempRange[0] && !tempRange[1])}
                                    >
                                        Publier mon offre
                                    </Button>
                                </div>

                                <div className="mrgB30"></div>

                            </div>
                        </form>
                        </div>
                        </div>
                    </>
                )}
            </>
      :
      <div className="loaderWrapper vertical">
            <Loader color="green" size="sm" type="dots" />
            <div className='mrgT5'>Chargement ...</div>
        </div>
    )
}

export default EditOfferBeforePublication;